import React from "react";
import { Table, InputGroup, FormControl } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectUser } from "../modules/Auth/_redux/authRedux";

export const ReportConsolidation = () => {

  const user = useSelector(selectUser);
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        title="Pivore Test"
        src={user?.report_consolidation_url}
        frameBorder="0"
        allowFullScreen
        style={{
          width: "100%",
          height: "80vh",
          maxWidth: "1200px",
          maxHeight: "700px",
        }}
      ></iframe>
    </div>
  );
};
